PJQ.models.contactus = {};

PJQ.models.contactus.ContactUs = PJQ.models.BaseModel.extend({
	idAttribute: "contactUsId",
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'contactus'
			}
		])
	}
});

PJQ.views.ContactUs = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contact-Us')
	},
	events: {
		'click .contactus-submit': 'onSubmit'
	},
	beforeFirstRender: function () {
	},
	beforeRender: function () {
		this.renderData = {};
	},
	afterRender: function () {
		PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contactus-phone'));
	},
	onSubmit: function () {
		let errors = 0;

		PJQ.helpers.inputHelpers.setInputError(this.$('.contactus-company'), true);
		if (this.$('.contactus-company').val().trim().length == 0) {
			PJQ.helpers.inputHelpers.setInputError(this.$('.contactus-company'), false);
			errors++;
		}

		PJQ.helpers.inputHelpers.setInputError(this.$('.contactus-contact'), true);
		if (this.$('.contactus-contact').val().trim().length == 0) {
			PJQ.helpers.inputHelpers.setInputError(this.$('.contactus-contact'), false);
			errors++;
		}

		let emailValid = PJQ.helpers.validators.validateEmail(this.$('.contactus-email').val());
		PJQ.helpers.inputHelpers.setInputError(this.$('.contactus-email'), emailValid.success);
		if (!emailValid.success)
			errors++;

		let phone = PJQ.helpers.formatHelpers.numbersOnly(this.$('.contactus-phone').val());

		if (errors == 0) {

			let model = new PJQ.models.contactus.ContactUs();
			let context = "Sub LP - General";
			if (this.getParameterByName('contactcontext'))
				context = this.getParameterByName('contactcontext');

			model.set('context', context);
			model.set('companyName', this.$('.contactus-company').val());
			model.set('contactName', this.$('.contactus-contact').val());
			model.set('phone', phone);
			model.set('email', this.$('.contactus-email').val());
			model.set('message', this.$('.contactus-message').val());

			model.save(null, {
				success: function () {
					window.location.href = 'http://app.panteratools.com/Default.aspx?tabid=21997';
				}
			});

			this.$('.contactus-company').val('');
			this.$('.contactus-contact').val('');
			this.$('.contactus-phone').val('');
			this.$('.contactus-email').val('');
			this.$('.contactus-message').val('');
		}
	},
	getParameterByName: function (name) {
		name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
		let regexS = "[\\?&]" + name + "=([^&#]*)";
		let regex = new RegExp(regexS);
		let results = regex.exec(window.location.search);
		if (results == null)
			return "";
		else
			return decodeURIComponent(results[1].replace(/\+/g, " "));
	}
});